import { useState } from "react";

import "../../assets/css/product.scss";
import Header from "../../components/header";
import Footer from "../../components/footer";

import ProductAuthModal from "../../components/modal/product_auth_modal";
import DonationList from "./donation_list";

function DonationStep2Component() {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <div className="product-list-container">
      <Header />
      <ul className="section1">
        <li>기부내역 조회하기</li>
        <li>
          정기 결제완료 시 Newspaper In Education ‘NIE’ 후원 캠페인에
          참여합니다.
          <br />
          사랑을 나누는 종이비행기 키즈다로 교육기부를 실천해보세요.
          <br />
          감사합니다.
          <br />
          기부 문의: 동아일보 교육법인 (주)동아이지에듀
          <br />
          Tel: 02-362-5109
        </li>
      </ul>
      <div className="section2">
        <DonationList />
      </div>
      <Footer />

      <ProductAuthModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        onSuccess={() => setIsModalOpen(false)}
      />
    </div>
  );
}

export default DonationStep2Component;
